export enum MealPlanTypeEnum {
  SMAE = 'SMAE',
  INTERNATIONAL = 'INTERNATIONAL',
}
